var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "8"
    }
  }, [_vm.canReadRepairEstimate ? _c('partner-report-cost-estimate-card', {
    staticClass: "mb-4"
  }) : _vm._e(), _vm.canReadAppraisal && _vm.canReadRepairEstimate ? _c('v-divider') : _vm._e(), _vm.canReadAppraisal ? _c('partner-report-appraisal-card', {
    staticClass: "mb-4"
  }) : _vm._e()], 1), !_vm.isMobile ? _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_vm.isMobile ? _c('v-divider') : _vm._e(), _c('partner-report-select-workshop-card', {
    staticClass: "mb-2"
  }), _c('v-divider'), _c('partner-report-select-appraiser-card', {
    staticClass: "mb-2"
  }), _c('v-divider'), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("objects.report.repair.title")) + " "), _c('v-spacer'), _vm.report.repair && _vm.report.repair.status === _vm.RepairStatusEnum.FINISHED && _vm.workshopSharedContent ? _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.reportRequestInformationDialog.open();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-open-in-new")]), _vm._v(" " + _vm._s(_vm.$t("report.completion.title")) + " " + _vm._s(_vm.$t("common.verbs.request")) + " ")], 1) : _vm._e(), _c('m-icon-button', {
    attrs: {
      "icon": !_vm.report.repair ? 'mdi-plus' : 'mdi-pencil-outline'
    },
    on: {
      "click": _vm.startAddRepairDetails
    }
  })], 1), !_vm.report.repair ? _c('v-card-text', [_c('m-no-content', {
    attrs: {
      "icon": "mdi-car-wrench",
      "text": _vm.$t('objects.report.repair.missing')
    }
  })], 1) : _vm.report.repair ? _c('v-card-text', [_c('partner-report-repair-info', {
    attrs: {
      "report": _vm.report
    }
  })], 1) : _vm._e(), _c('report-request-information-dialog', {
    ref: "reportRequestInformationDialog",
    attrs: {
      "report": _vm.report,
      "screens": [_vm.ReportScreenEnum.COMPLETION],
      "name": "".concat(_vm.$t('common.verbs.request').toString(), " ").concat(_vm.$t('report.completion.title').toString(), " ").concat(_vm.report.claimNumber, " ").concat(_vm.report.title),
      "sharedContent": _vm.workshopSharedContent
    }
  }), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t("objects.report.repair.add"),
      "icon": "mdi-car-wrench",
      "isDialogActive": _vm.isRepairDialogOpen,
      "rightDisabled": !_vm.isRepairValid,
      "rightLoading": _vm.isRepairLoading,
      "hideLeft": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isRepairDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isRepairDialogOpen = $event;
      },
      "rightClick": _vm.updateRepairDetails
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isRepairValid,
      callback: function callback($$v) {
        _vm.isRepairValid = $$v;
      },
      expression: "isRepairValid"
    }
  }, [_c('repair-detail-form', {
    model: {
      value: _vm.updateRepair,
      callback: function callback($$v) {
        _vm.updateRepair = $$v;
      },
      expression: "updateRepair"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('partner-report-clearances-card', {
    staticClass: "mb-2"
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }